import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=e9878628"
import script from "./roleAdd.vue?vue&type=script&lang=js"
export * from "./roleAdd.vue?vue&type=script&lang=js"
import style0 from "./roleAdd.vue?vue&type=style&index=0&id=e9878628&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports